import React, { useContext, useState } from "react";
import { AppContext, DecryptSession } from "../../Context/Provider";
import {
  getPasswordRuleStates,
  validatePassword,
} from "../../Utilities/validatePassword";

function ChangePasswordPage() {
  const { ChangePassword, secretKey } = useContext(AppContext);
  const session = DecryptSession(secretKey, "userId");
  const username = session?.data?.username || "";
  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const passwordRules = getPasswordRuleStates(password, username);

  const handleSubmit = async () => {
    if (!oldPassword) {
      setError("Please enter your current password.");
      return;
    }

    const passwordError = validatePassword(password, username);
    if (passwordError) {
      setError(passwordError);
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setError("");
    setIsSubmitting(true);
    try {
      await ChangePassword({ oldPassword, password, confirmPassword });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="bg-gray-50">
      <div className="flex min-h-screen items-center justify-center px-6 py-8">
        <div className="w-full max-w-md rounded-lg bg-white p-6 shadow sm:p-8">
          <h1 className="mb-2 text-2xl font-bold text-gray-900">
            Change your password
          </h1>
          <p className="mb-6 text-sm text-gray-600">
            You must set a new password before continuing.
          </p>

          {error ? (
            <div className="mb-4 rounded border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
              {error}
            </div>
          ) : null}

          <div className="space-y-4">
            <input
              type="password"
              value={oldPassword}
              onChange={(event) => setOldPassword(event.target.value)}
              placeholder="Current password"
              className="block w-full rounded-lg border border-gray-300 p-2.5"
            />
            <input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="New password"
              className="block w-full rounded-lg border border-gray-300 p-2.5"
            />
            <input
              type="password"
              value={confirmPassword}
              onChange={(event) => setConfirmPassword(event.target.value)}
              placeholder="Confirm new password"
              className="block w-full rounded-lg border border-gray-300 p-2.5"
            />

            <div className="rounded bg-gray-50 p-4 text-sm text-gray-700">
              <p className="mb-2 font-semibold">Password policy</p>
              <ul className="list-disc space-y-1 pl-5">
                {passwordRules.map((rule) => (
                  <li
                    key={rule.key}
                    className={rule.passed ? "text-green-600" : "text-red-600"}
                  >
                    {rule.label}
                  </li>
                ))}
              </ul>
            </div>

            <button
              type="button"
              disabled={isSubmitting}
              onClick={handleSubmit}
              className="w-full rounded-lg bg-custom-green px-5 py-2.5 text-sm font-medium text-white disabled:opacity-70"
            >
              {isSubmitting ? "Changing password..." : "Change password"}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ChangePasswordPage;
